export const Holidays: any[] = [
  {
    date: '2016-01-01',
    description: 'New Year day',
  },
  {
    date: '2016-01-18',
    description: 'Martin Luther King Jr. day',
  },
  {
    date: '2016-02-15',
    description: 'Presidents Day (Washingtons Birthday)',
  },
  {
    date: '2016-05-30',
    description: 'Memorial day',
  },
  {
    date: '2016-07-04',
    description: 'Independence day',
  },
  {
    date: '2016-09-05',
    description: 'Labor day',
  },
  {
    date: '2016-11-24',
    description: 'Thanksgiving day',
  },
  {
    date: '2016-12-26',
    description: 'Christmas day',
  },
  {
    date: '2017-01-02',
    description: 'New Year day',
  },
  {
    date: '2017-01-16',
    description: 'Martin Luther King Jr. day',
  },
  {
    date: '2017-02-20',
    description: 'Presidents Day (Washingtons Birthday)',
  },
  {
    date: '2017-05-29',
    description: 'Memorial day',
  },
  {
    date: '2017-07-04',
    description: 'Independence day',
  },
  {
    date: '2017-09-04',
    description: 'Labor day',
  },
  {
    date: '2017-11-23',
    description: 'Thanksgiving day',
  },
  {
    date: '2017-12-25',
    description: 'Christmas day',
  },
  {
    date: '2018-01-01',
    description: 'New Year day',
  },
  {
    date: '2018-01-15',
    description: 'Martin Luther King Jr. day',
  },
  {
    date: '2018-02-19',
    description: 'Presidents Day (Washingtons Birthday)',
  },
  {
    date: '2018-05-28',
    description: 'Memorial day',
  },
  {
    date: '2018-07-04',
    description: 'Independence day',
  },
  {
    date: '2018-09-03',
    description: 'Labor day',
  },
  {
    date: '2018-11-22',
    description: 'Thanksgiving day',
  },
  {
    date: '2018-12-25',
    description: 'Christmas day',
  },
  {
    date: '2019-01-01',
    description: 'New Year day',
  },
  {
    date: '2019-01-21',
    description: 'Martin Luther King Jr. day',
  },
  {
    date: '2019-02-18',
    description: 'Presidents Day (Washingtons Birthday)',
  },
  {
    date: '2019-04-19',
    description: 'Good Friday',
  },
  {
    date: '2019-05-27',
    description: 'Memorial day',
  },
  {
    date: '2019-07-04',
    description: 'Independence day',
  },
  {
    date: '2019-09-02',
    description: 'Labor day',
  },
  {
    date: '2019-11-28',
    description: 'Thanksgiving day',
  },
  {
    date: '2019-12-25',
    description: 'Christmas day',
  },
  {
    date: '2020-01-01',
    description: 'New Year day',
  },
  {
    date: '2020-01-20',
    description: 'Martin Luther King Jr. day',
  },
  {
    date: '2020-02-17',
    description: 'Presidents Day (Washingtons Birthday)',
  },
  {
    date: '2020-04-10',
    description: 'Good Friday',
  },
  {
    date: '2020-05-25',
    description: 'Memorial day',
  },
  {
    date: '2020-07-03',
    description: 'Independence day',
  },
  {
    date: '2020-09-07',
    description: 'Labor day',
  },
  {
    date: '2020-11-26',
    description: 'Thanksgiving day',
  },
  {
    date: '2020-12-25',
    description: 'Christmas day',
  },
];
